export interface ExternalEvaluation {
    id?: number;
    externalEvaluatorId: string;
    creationUserId: string;
    subjectCycleParticipantId: string;
    field1: string;
    field2: string;
    field3: string;
    field4: string;
    field5: string;
    field6: string;
    field7: string;
    field8: string;
    field9: string;
    field10: string;
    field11: string;
    field12: string;
    field13: string;
    field14: string;
    field15: string;
    status: ExternalEvaluationStatus;
    type: ExternalEvaluationType;
}

export enum ExternalEvaluationType {
    FreeEvaluationMidYear = 0,
    FreeEvaluationEndYear = 1,
    ThreeSixtyEvaluation = 2,
    ThreeSixtyEvaluationGroupCompanies = 3,
}


export enum ExternalEvaluationStatus {
    AwaitingAuthorization = 0,
    NotSent = 1,
    Sent = 2
}
